import React from 'react';
import { errorIcon } from '../assets/images'
import { useNavigate } from 'react-router-dom';

export default function ApplicationCancelled() {
    const navigate = useNavigate();
    return (
        <div className="customContainer thankyouPage payment-received">
            <div className="thankyouDetails text-center">
                <div className="form-group">
                    <img src={errorIcon} alt="" className="thankyouIcon" />
                </div>
                <h2>Application Cancelled!</h2>
                <p style={{ fontWeight: "300" }}>
                    Your Application is cancelled, you can re-apply with new application. 
                </p>
                <div>
                    <button
                        onClick={() => { navigate("/", { replace: true }) }}
                        className="btn btn-primary"
                    >
                        Go to Home
                    </button>
                </div>
            </div>
        </div>
    )
}
